import React from "react";
import styles from "./ArticleOption.module.css";
import clsx from "clsx";
import Link from "common/Link";
import useImagePath from "hooks/useImagePath";
import { UrlUtils } from "utils/url-utils";
import { handlePushClickEventToGTM } from "utils/pushClickEventToGTM";
import { IArticleOption } from "components/ArticleListing/ArticleListing.interface";

const ArticleOption = ({
  thumbnailPath,
  title,
  setTitle,
  firstImage,
  url,
  tagIds,
}: IArticleOption) => {
  const { imageRenderPath } = useImagePath(thumbnailPath, styles.img_base);

  const setCategoryTag = (categoryTag: { name: string; key: string }) => () => {
    handlePushClickEventToGTM("ArticleListingCategoryTag", categoryTag.name);
    setTitle(categoryTag);
  };

  return (
    <div
      className={clsx(
        styles.article_base,
        firstImage ? styles.first_article : "col-span-1"
      )}
    >
      <div>
        <Link
          to={UrlUtils.getShortUrl(url)}
          onClick={() => handlePushClickEventToGTM("ArticleListingItem", title)}
          className="appearance-none !no-underline"
        >
          <img
            className={clsx(
              styles.img_base,
              firstImage ? styles.large_img : styles.regular_img
            )}
            src={imageRenderPath}
            alt="article img"
          />
        </Link>
        <ul className={styles.subtitle_container}>
          {tagIds?.map((tag, index) => (
            <li key={index} className={styles.subtitle_item}>
              {index > 0 && <p>{"·"}</p>}
              <p
                onClick={setCategoryTag({
                  name: tag.value,
                  key: tag.key,
                })}
                className={styles.subtitle_text}
              >
                {tag.value}
              </p>
            </li>
          ))}
        </ul>
        <Link
          to={UrlUtils.getShortUrl(url)}
          onClick={() => handlePushClickEventToGTM("ArticleListingItem", title)}
          className="appearance-none !no-underline"
        >
          <p className={styles.title}>{title}</p>
        </Link>
      </div>
    </div>
  );
};

export default ArticleOption;
